module.exports = __webpack_public_path__ + "img/c02_unitcamelriderchampion_Normal_ua.0b7181ed.webp";